// extracted by mini-css-extract-plugin
module.exports = {"container":"part-services_container__XzbIl","service":"part-services_service__EwPLO","title":"part-services_title__yukJ6"};